import { FollowButton } from 'components/elements'
import { useRouter } from 'next/router'
import styled, { css } from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const TagsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  max-width: 586px;
  margin: -5px 0 20px;
  width: 100%;
`

const StyledFollowTab = styled(FollowButton)`
  margin: 4px;
  background-color: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.primary};
  border-color: ${({ theme }) => theme.colors.primary};
  &::before {
    content: ${({ desc }) => `'${desc}'`} !important;
  }

  &:hover {
    background-color: ${({ theme }) => theme.colors.primary};
    color: ${({ theme }) => theme.colors.white};
    border-color: ${({ theme }) => theme.colors.white};
  }

  ${({ isFollowing }) =>
    isFollowing &&
    css`
      background-color: ${({ theme }) => theme.colors.primary};
      color: ${({ theme }) => theme.colors.white};
      border-color: ${({ theme }) => theme.colors.white};
    `}
`

export const CustomFollowTag = ({ name, slug }) => {
  const router = useRouter()

  const handleClick = () => {
    router.push(`/topics/${slug}`)
  }

  return <StyledFollowTab desc={name} onClick={handleClick} show />
}

export const EmptyMessage = styled.div`
  color: ${({ theme }) => theme.colors.grey};
`
